<template>
    <div class="page-layout blank contacts-manage">
       <div class="pb-10 pr-3 pl-3">
        <!-- Breadcrumb Section -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                    <div class="breadcrumbnew">
                        <span><router-link to="/contacts/list_contacts" class="text-white pl-2 text-line">Dashboard</router-link></span>
                    </div>
                    <button type="button" class="btn btn-smm text-white call-report-btn ml-3 " @click="$router.push('/create_contact/new')"  style="border-radius: 6px !important;">
                        <i class="icon icon-plus fs-12 text-white" style="color: #fff !important;"></i>
                        Create New Contacts
                    </button>
                </div>
            </div>
            <div class="ml-4 mr-4">
                <div class="row">
                    <div class="col-lg-12 bg-white pl-3 pb-3 contact-list">
                        <div class="row pr-3">
                            <!-- Contacts list view Section -->
                            <div class="col-lg-8 col-md-12 col-sm-12 pr-0 pl-4">
                                <fullscreen ref="contactlist" @change="dataChange('contactlist')" class="box-radius bg-white">
                                    <div class="d-flex justify-content-between align-items-center pl-1 pt-4 pb-4">
                                        <div class="fw-600 fs-14 d-flex justify-content-start align-items-center">Contacts List
                                            <div class="d-flex ml-2 " style="flex-grow: 1;border: 1px solid #ddd !important;border-radius: 24px !important;">
                                                <i class="icon icon-magnify icon-default-board fs-20" style="background-color: #fff !important;color: #a6a5a7 !important;"></i>
                                                <input class="w-100 dashboard-placeholder-text searchText" type="text" v-model="search_key"
                                                    v-debounce:500ms="searchContact" debounce-events="input" placeholder="Search"  style="background-color: #fff !important;">
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <button type="button" class="btn btn-smm text-white ml-3 p-0 schedule-meeting-btn" disabled>
                                                <i class="icon icon-plus fs-12 text-white"  style="color: #fff !important;"></i>
                                                Schedule Meeting
                                            </button>
                                            <el-dropdown trigger="click" style="width: 120px;">
                                                <button type="button" class="btn btn-smm text-white p-0 call-report-btn ml-3" >
                                                    <i class="icon icon-plus fs-12 text-white" style="color: #fff !important;"></i>
                                                    Call Report
                                                </button>
                                                <el-dropdown-menu slot="dropdown" class="call-report-dropdown contact-dash">
                                                    <!-- <el-dropdown-item v-for="(category, index) in call_report_category_options"
                                                        :key="index" @click.native="createCallReport(category)">{{ category }}
                                                    </el-dropdown-item> -->
                                                    <el-dropdown-item @click.native="createCallReport('External Meeting')">External Meeting</el-dropdown-item>
                                                    <el-dropdown-item @click.native="createCallReport('Internal Meeting')">Internal Meeting</el-dropdown-item>
                                                    <el-dropdown-item @click.native="createCallReport('Review Meeting')">Review Meeting</el-dropdown-item>
                                                    <el-dropdown-item @click.native="createCallReport('Sales Meeting')">Sales Meeting</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                            <button type="button" class="pointer bg-white icon-outline-css ml-6 pr-7" @click="expandData('contactlist'), listTable()">
                                                    <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt style="width: 32px !important; height: 32px !important;cursor: pointer !important;"/>
                                            </button>
                                        </div>
                                    </div>
                                    <table id="listTable" class="contact-list-table table table-responsive">
                                        <thead class="fw-600 column-heading" v-if="data_list.length != 0">
                                            <th class="w-1 whiteSpace">Contact Name</th>
                                            <th class="whiteSpace">Deal Name</th>
                                            <th class="whiteSpace">Company Name</th>
                                            <th class="whiteSpace">Industry Type</th>
                                            <th class="whiteSpace">Email ID</th>
                                            <th class="whiteSpace">Mobile Number</th>
                                        </thead>
                                        <tbody>
                                            <tr class="w-100" v-if="ajaxCallInProgress && !data_list.length">
                                                <td colspan="15">
                                                    <div class="d-flex align-items-center justify-content-center"
                                                        style="height: 330px; width: 890px;"
                                                        v-if="ajaxCallInProgress">
                                                        <half-circle-spinner :animation-duration="1000" :size="50"
                                                            color="#00448b" style="margin: 0 auto;" />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="!ajaxCallInProgress && data_list.length == 0" class="text-center">
                                                <td colspan="15">
                                                    <img src="/static/images/contact-list.png" class="mb-3 response-list" style="width: 50%!important; height: 50%!important; margin-top: 35px!important;"/>
                                                    <div class="text-center text-muted mt-5 fw-500">No contacts added!</div>
                                                </td>
                                            </tr>
                                            <template v-else v-for="(i,contact_index) in data_list">
                                                <tr class="cont-table-row" @click="loadDealsData(i.deals[0].id,i.deals[0].name)" :key="contact_index" v-on:click="selectItem(contact_index)" v-bind:class="{ active: contact_index === activeItem }">
                                                    <td>
                                                        <div class="text-color pointer d-flex align-items-center">
                                                            <span v-if="i.deals.length > 1" @click="showRequest(i)" class="pointer">
                                                                <i v-if="i.expanded" class="icon icon-menu-down text-new-blue" style="font-size: 30px !important;"></i>
                                                                <i v-else class="icon icon-menu-right text-new-blue" style="font-size: 30px !important;"></i>
                                                            </span>
                                                            <span v-else class="pl-3"></span>
                                                            <span style="white-space: nowrap">{{i.full_name}}</span>
                                                        </div>
                                                    </td>
                                                    <td class="pointer text-color" style="white-space: nowrap">{{i.deals[0].name }}</td>
                                                    <td style="white-space: nowrap">{{i.company_name || "-"}}</td>
                                                    <td class="text-truncate" style="max-width: 100px;" :title="i.industry_type">{{i.industry_type || "-"}}</td>
                                                    <td class="text-truncate" style="max-width: 120px;" :title="i.primary_email">{{i.primary_email || "-"}}</td>
                                                    <td style="white-space: nowrap">{{i.mobile_number || "-"}}</td>
                                                </tr>
                                                <transition name="fade" :key="index" v-for="(deal,index) in i.deals">
                                                    <tr class="cont-table-row" @click="loadDealsData(deal.id,deal.name)" v-if="i.expanded && index != 0">
                                                        <td>-</td>
                                                        <td class="pointer text-color" style="white-space: nowrap">{{deal.name}}</td>
                                                        <td>{{i.company_name }}</td>
                                                        <td>{{i.industry_type}}</td>
                                                        <td>{{i.primary_email}}</td>
                                                        <td>{{i.mobile_number}}</td>
                                                    </tr>
                                                </transition>
                                            </template>
                                        </tbody>
                                    </table>
                                </fullscreen>
                            </div>
                            <!-- Deal details Section -->
                            <div class="col-lg-4 col-md-12 col-sm-12  pl-5 pr-0 pt-16">
                                <fullscreen ref="dealdetails" @change="dataChange('dealdetails')" class="box-radius bg-white">
                                    <div id="dealDetails" class="deals-details">
                                        <div class="d-flex justify-content-between align-items-center pl-6 p-4">
                                            <span class="fw-600 fs-14">{{deal_name}} Deal details</span>
                                            <div>
                                                <button type="button" class="deal-details-btn p-0" @click="$router.push('/deals/createdeal/new')">
                                                    <el-tooltip class="item" effect="dark" content="Create Deal" placement="top">
                                                        <i class="icon icon-plus fs-20 text-white"></i>
                                                    </el-tooltip>
                                                </button>
                                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('dealdetails'), dealDetails()">
                                                    <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt />
                                                </button>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center justify-content-center" v-if="loadDealDetailsSection" style="height: 300px;">
                                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                        </div>
                                        <div v-else>
                                            <ul class="nav nav-tabs menu">
                                                <li class="nav-item tabBtn" :class="{'active-tab':show_notes}" @click="switchTabs('notes')">
                                                    <a class="nav-link-cd btn fw-600 column-heading">Notes ({{list_notes ? list_notes.count : 0}})</a>
                                                </li>

                                                <li class="nav-item tabBtn" :class="{'active-tab':show_products}" @click="switchTabs('products')">
                                                    <a class="nav-link-cd btn fw-600 column-heading">Products ({{list_products ? list_products.count : 0}})</a>
                                                </li>

                                                <li class="nav-item tabBtn" :class="{'active-tab':show_attachments}" @click="switchTabs('attachments')">
                                                    <a class="nav-link-cd btn fw-600 column-heading">Attachments ({{list_attachments ? list_attachments.count : 0}})</a>
                                                </li>
                                            </ul>
                                            <div id = "vertical-scroll" class="vertical-scroll">
                                                <div v-if="show_notes && list_notes == null || show_products && list_products == null || show_attachments && list_attachments == null" class="mt-10 text-center">
                                                    <img class="empty-deal-details pt-2" src="/static/images/dashboard/lead-details-image.svg">
                                                    <p class="pt-5 text-muted fw-500">Deals associated with Contacts!</p>
                                                </div>
                                                <div v-if="show_notes && list_notes" class="d-flex flex-column p-2 mt-2 mx-4 bordrad-5px notes-parent">
                                                    <div class v-if="list_notes.count == 0">
                                                        <p class="pt-6 pb-4 text-muted fw-500 d-flex justify-content-center">No Notes to Display!</p>
                                                    </div>
                                                    <div class="d-flex justify-content-between fw-500" v-for="(notes,notes_index) in list_notes.response" :key="notes_index">
                                                        {{notes.notes}}
                                                    </div>
                                                </div>
                                                <div v-if="show_products && list_products">
                                                    <div v-if="list_products.count == 0" class="d-flex flex-column p-2 mt-2 mx-4 bordrad-5px notes-parent">
                                                        <p class="pt-6 pb-4 text-muted fw-500 d-flex justify-content-center">No Products to Display!</p>
                                                    </div>
                                                    <div v-for="(products,products_index) in list_products.response" :key="products_index" class="d-flex flex-column p-2 mt-2 mx-4 bordrad-5px notes-parent">
                                                        <div class="d-flex justify-content-between">
                                                            <div class="row">
                                                                <div class="col-lg-2 col-md-2 col-sm-12">
                                                                    <img class="pt-10" src="/static/images/dashboard/scm-product-image.png">
                                                                </div>
                                                                <div class="col-lg-10 col-md-10 col-sm-12 fw-500">
                                                                    <p>{{products.product_name}}</p>
                                                                    <p>Quantity : {{products.quantity}}</p>
                                                                    <p>Transaction Value Per Unit (K) : {{products.transaction_value}}</p>
                                                                    <p>Transaction Value (K) : {{products.transaction_value_per_unit}}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="show_attachments && list_attachments" class="d-flex flex-column p-1 mt-2 mx-4 bordrad-5px notes-parent">
                                                    <div>
                                                        <div class v-if="list_attachments.count == 0">
                                                            <p class="pt-6 pb-4 text-muted fw-500 d-flex justify-content-center">No Attachments to Display!</p>
                                                        </div>
                                                        <!-- <div class="d-flex align-items-center justify-content-between" v-for="attachments in list_attachments.response" :key="attachments.url">
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <span class="_images clickImg" @click="previewImage(attachments)">
                                                                    <img v-if="attachments.url.endsWith('.pdf')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" />
                                                                    <img v-else-if="attachments.url.endsWith('.svg')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                                                    <img v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" />
                                                                    <img v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" />
                                                                    <img v-else :src="attachments.url" alt="">
                                                                </span>
                                                            </div>
                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                <p class="pt-4 fw-500">{{attachments.name}}</p>
                                                                <div class="fw-500">({{attachments.size | prettyBytes}})
                                                                </div>
                                                            </div>
                                                        </div> -->

                                                        <div class="d-flex flex-column"  v-for="attachments in list_attachments.response" :key="attachments.url">
                                                            <div class="d-flex align-items-center mb-5">
                                                                <div class="attachemntimg attachemntimg-80px me-5 clickImg" @click="previewImage(attachments)">
                                                                    <img v-if="attachments.url.endsWith('.pdf')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg" style="width: 48px;"/>
                                                                    <img v-else-if="attachments.url.endsWith('.svg')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" style="width: 48px;"/>
                                                                    <img v-else-if="attachments.url.endsWith('.xls') || attachments.name.endsWith('.xlsx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg" style="width: 48px;"/>
                                                                    <img v-else-if="attachments.url.endsWith('.doc') || attachments.name.endsWith('.docx')"
                                                                        src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg" style="width: 48px;"/>
                                                                    <img v-else :src="attachments.url" alt="">
                                                                </div>
                                                                <div class="fw-semibold">
                                                                    <a class="fs-6 fw-bold text-dark text-hover-primary" href="javascript:;">
                                                                        {{attachments.name}}
                                                                    </a>
                                                                    <div class="text-gray-400">
                                                                        ({{attachments.size | prettyBytes}})
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fullscreen>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Amount associated with Contact Section -->
                    <div class="col-lg-4 col-md-12 clo-sm-12 p-0">
                        <fullscreen ref="amount" @change="dataChange('amount')" class="mr-3 box-radius bg-white">
                            <div class="bg-white mt-3 mr-3 box-radius">
                                <div class="d-flex justify-content-between align-items-center pl-4 pt-4 pb-4 pr-2">
                                    <div class="fw-600 fs-14">Amount associated with Contacts</div>
                                    <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('amount'), contactsExpand()">
                                        <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadContactsSmountSection" style="height: 358px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else id="amountContactsDiv" class="amountContactsDiv"></div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Revenue Generated Section -->
                    <div class="col-lg-4 col-md-12 clo-sm-12 p-0">
                        <fullscreen ref="revenue" @change="dataChange('revenue')" class="mr-3 box-radius bg-white">
                            <div class="bg-white mt-3 mr-3 box-radius">
                                <div class="d-flex justify-content-between align-items-center pl-3 pt-4 pb-4 pr-2">
                                    <div class="fw-600 fs-14">Revenue generated</div>
                                    <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('revenue'), revenueExpand()">
                                        <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt />
                                    </button>
                                </div>
                                <div class="d-flex align-items-center justify-content-center" v-if="loadRevenueGeneratedSection" style="height: 358px;">
                                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <div v-else class="p-3">
                                    <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                        <div class="d-flex justify-content-between align-items-center"
                                            style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                            <input type="text"
                                                :value="('0'+new Date(dateRange[0]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                                style="color: #fff; background: #41b883; width: 14em;" disabled />
                                            <span
                                            @click="dataClose('contact'),dateRange= []"
                                            style="color: #fff; cursor: pointer;">&#10005;</span>
                                        </div>
                                    </div>
                                    <date-picker v-else @change="updatecreationDate()" v-model="dateRange" format="DD/MM/YYYY"
                                            range class="date-width calendar-edit-per callreport-listdate calendar-height-top" :show-second="false"
                                        :lang="lang" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                                    </date-picker>
                                </div>
                                <div v-if="!loadRevenueGeneratedSection" id="revenueGeneratedDiv" class="revenueGeneratedDiv"></div>
                            </div>
                        </fullscreen>
                    </div>
                    <!-- Deal action log Section -->
                    <div class="col-lg-4 col-md-12 clo-sm-12 bg-white pr-0 pl-3 action-log">
                        <fullscreen ref="actionlog" @change="dataChange('actionlog')" class="box-radius bg-white">
                            <div class="action-div mr-3 mb-3">
                                <div id="deal-action" class="deal-action">
                                    <div class="d-flex justify-content-between align-items-center pl-6 p-4">
                                        <div class="fw-600 fs-14">{{deal_name}} Deal Action Log</div>
                                        <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('actionlog'), actionLogExpand()">
                                            <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt />
                                        </button>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center" v-if="loadActionLogSection" style="height: 300px;">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <div v-else>
                                        <table id="actionLogTable" class="action-log-table team-list-table table table-responsive">
                                            <thead class="fw-600 column-heading">
                                                <th class="w-1 whiteSpace" style="border-right: 1px solid #fff;">Action</th>
                                                <th class="w-1 whiteSpace" style="border-right: 1px solid #fff;">Date and Time</th>
                                                <th class="w-1 whiteSpace">User Name</th>
                                            </thead>
                                            <tbody>
                                                <tr v-if="action_logs.length == 0" class="font-weight-bold">
                                                <div class="no_data mt-13">
                                                    <img class="empty-deal-details" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/add_reminders.svg" alt=""/>
                                                    <p class="pt-5 text-muted fw-500">No log to display yet!</p>
                                                </div>
                                                </tr>
                                                <tr v-else v-for="data in action_logs" :key="data.action">
                                                    <td>{{data.action}}</td>
                                                    <td>{{data.changed_time}}</td>
                                                    <td>{{data.changed_by_name}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </fullscreen>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <preview @hidePreview="hidePreview" v-if="preview_visible" :file_preview="preview_file"></preview>
    </div>
</template>

<script>
import dashboard from '../mixins/dashboard'
import deals from '../mixins/deals'
import call_report from "../mixins/callreport";
import {HalfCircleSpinner} from "epic-spinners";
import { SweetModal } from 'sweet-modal-vue';
import convert from "../mixins/convert.js";
const Preview = () => import('../Preview');
var mime = require('mime-types');
export default {
    data(){
        return {
            loadContactsSmountSection: false,
            loadDealDetailsSection: false,
            activeItem: 0,
            currency:'',
            graph_scale:[],
            scale_data:[],
            search_key:'',
            loadActionLogSection: false,
            loadRevenueGeneratedSection: false,
            ajaxCallInProgress: false,
            warning_msg: '',
            deal_name:'',
            success_msg: '',
            show_notes:true,
            show_products: false,
            show_attachments: false,
            show_action: true,
            show_dateTime: false,
            show_userName: false,
            chart: {},
            list_data: [],
            data_list:[],
            list_notes: null,
            list_products: null,
            list_attachments: null,
            action_logs: [],
            contacts_data: null,
            revenue_data: [],
            created_report_date: [new Date() , new Date()],
            rangeDate: [],
            dateRange: [],
            creation_date: [],
            preview_file: '',
            preview_visible: false,
            pickerOptions:{
                disabledDate(time){
                    return time.getTime() > Date.now();
                }
            },
            lang: {
                type: "en",
                days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days"
                ],
                placeholder: {
                    date: "Select Date",
                    dateRange: "Select Date Range"
                },
                expand_div:false


            },
            //call_report_category_options: [],
        }
    },
    mixins: [dashboard, deals, convert, call_report],
    components: {
        HalfCircleSpinner,
        SweetModal,
        Preview
    },
    methods:{
        selectItem(i) {
            this.activeItem = i;
        },
        //Redirects to cretae call report page
        createCallReport(category) {
            this.$store.commit("setCallReportCategory", category);
            localStorage.setItem("callReportCategory", category)
            this.$router.push("/callreport");
        },
        // viewSendCallReport(callReport_id) {
        //     if(this.userPermissions.call_reports.permitted_actions.view || this.userPermissions.draft_call_reports.permitted_actions.view){
        //         this.$router.push("/viewcallreport/" + callReport_id);
        //     }
        //     else{
        //         this.$toasted.global.error("Permission Denied")
        //     }
        // },
        // getCallReportType() {
        //     this.$http.get("/call_report/get_call_report_category").then(res => {
        //         if (res.data.status_id == 1) {
        //             res.data.response.value.forEach(x => {
        //                 this.call_report_category_options.push(x.name);
        //             });
        //         }
        //     });
        // },
        dataClose(val){
            let date = this.rangeDate
            let start_date = this.convertFilter(date[0])
            let end_date = this.convertFilter(date[1])
            let newValue = start_date + ',' + end_date
            newValue = newValue.split(",")
            this.created_report_date = newValue
            this.loadRevenueGeneratedAPI()
        },
        previewImage(file) {
            let content_type = mime.lookup(file.name) ? mime.lookup(file.name) : 'application/octet-stream';
            file['content_type'] = content_type;
            this.preview_file = file;
            this.preview_visible = true;
        },
        hidePreview() {
            this.preview_visible = false
        },
        dateSettings(){
            let date = []
            var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
            var newDate = this.convertFilter(new Date());
            var oldDate = new Date();
            oldDate.setTime(oldDate.getTime() - dateOffset);
            this.created_report_date= [this.convertFilter(oldDate),newDate]
            this.rangeDate = [this.convertFilter(oldDate),newDate]
        },
        //Fullscreen methods
        contactsExpand(){
            var contactsAmount = document.getElementById('amountContactsDiv');
            contactsAmount.classList.toggle('amountContactsDiv');
            contactsAmount.classList.toggle('amountContactsDiv-expand');
        },
        revenueExpand(){
            var revenue = document.getElementById('revenueGeneratedDiv');
            revenue.classList.toggle('revenueGeneratedDiv');
            revenue.classList.toggle('revenueGeneratedDiv-expand');
        },
        actionLogExpand(){
            var actionLog = document.getElementById('actionLogTable');
            actionLog.classList.toggle('action-log-table');
            actionLog.classList.toggle('action-log-table-expand');
            var dealAction = document.getElementById('deal-action');
            dealAction.classList.toggle('deal-action');
            dealAction.classList.toggle('deal-action-expand');
        },
        listTable(){
            var contactList = document.getElementById('listTable');
            contactList.classList.toggle('contact-list-table');
            contactList.classList.toggle('contact-list-table-expand');
        },
        dealDetails(){
            var dealDetails = document.getElementById('dealDetails');
            dealDetails.classList.toggle('deals-details');
            dealDetails.classList.toggle('deal-details-expand');
            var verticalScroll = document.getElementById('vertical-scroll');
            verticalScroll.classList.toggle('vertical-scroll');
            verticalScroll.classList.toggle('vertical-scroll-expand');
        },
        updatecreationDate(){
            if (this.dateRange) {
                let start_date = this.convertFilter(this.dateRange[0])
                let end_date = this.convertFilter(this.dateRange[1])
                let newValue = start_date + ',' + end_date
                newValue = newValue.split(",")
                this.created_report_date = newValue
                this.loadRevenueGeneratedAPI()
            } else {
                this.creation_date = ''
                this.created_report_date = ''
            }
            this.$forceUpdate()

        },
        expandData(value) {
            if(value == 'revenue'){
                this.$refs["revenue"].toggle();
                this.revenueExpand();
            } else if(value == 'actionlog'){
                this.$refs["actionlog"].toggle();
                this.actionLogExpand();
            } else if(value == 'dealdetails'){
                this.$refs["dealdetails"].toggle();
                this.dealDetails();
            }else if(value == 'contactlist'){
                this.$refs["contactlist"].toggle();
                this.listTable();
            }else if(value == 'amount'){
                this.$refs["amount"].toggle();
                this.contactsExpand();
            }
        },
        dataChange(value) {
            if(value == 'revenue'){
                this.revenue = value;
                this.revenueExpand();
            } else if(value == 'actionlog'){
                this.actionlog = value;
                this.actionLogExpand();
            } else if(value == 'dealdetails'){
                this.dealdetails = value;
                this.dealDetails();
            }else if(value == 'contactlist'){
                this.contactlist = value;
                this.listTable();
            } else if(value == 'amount'){
                this.amount = value;
                this.contactsExpand();
            }
        },
        searchContact() {
            this.skip = 0;
            this.data_list = [] ,
            this.loadContactListData()
        },
        async showRequest(list){
            list.expanded = !list.expanded
            this.$forceUpdate()
        },
        //Switches tabs
        switchTabs(obj){
            if(obj == 'notes'){
                this.show_notes = true
                this.show_products = false
                this.show_attachments = false
            }
            else if(obj == 'products'){
                this.show_products = true
                this.show_notes = false
                this.show_attachments = false
            }
            else {
                this.show_attachments = true
                this.show_notes = false
                this.show_products = false
            }
        },
        actionLogSwitchTabs(action){
            if(action == 'action'){
                this.show_action = true
                this.show_dateTime = false
                this.show_userName = false
            }
            else if(action == 'date'){
                this.show_dateTime = true
                this.show_action = false
                this.show_userName = false
            }
            else {
                this.show_userName = true
                this.show_action = false
                this.show_dateTime = false
            }
        },
        //API call to get all contacts data
        async loadContactListData(){
            this.ajaxCallInProgress = true;
            this.activeItem = 0;
            let params = {
                skip: 0,
                limit: 10,
                search_key: this.search_key,
                sort_key: "id",
                sort_value: -1,
            }
            let response = await this.getContactListData(params)
            this.data_list = response.response
           /* this.data_list = this.data_list.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.data_list.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });*/
            this.list_data = response
            this.list_data.response.forEach(x => {
                x.deals.forEach(y => {
                    y['expanded'] = false
                })
            })
            this.ajaxCallInProgress = false;
            this.loadDealsData(this.data_list[0].deals[0].id,this.data_list[0].deals[0].name)
        },
        //Based on selected contacts associated notes, products, attachments and action log APIs will call
        loadDealsData(id,name){
            // console.log(id, name)
            this.loadDealDetailsSection = true;
            this.deal_name = name
            this.loadDealsNotes(id)
            this.loadDealsProducts(id)
            this.loadDealsAttachments(id)
            this.loadActionLog(id)
            setTimeout(() => {
                this.loadDealDetailsSection = false;
            }, 1000);
        },
        //API call to get deal notes
        async loadDealsNotes(id){
            let params = {
                id: id,
                skip: 0,
                limit: 10
            }
            let response = await this.getDealsNotesData(params)
            this.list_notes = response
        },
        //API call to get deal products
        async loadDealsProducts(id){
            let params = {
                id: id,
                skip: 0,
                limit: 10
            }
            let response = await this.getDealsProductsData(params)
            this.list_products = response
        },
        //API call to get deal attachments
        async loadDealsAttachments(id){
            let params = {
                id: id,
                skip: 0,
                limit: 10
            }
            let response = await this.getDealsAttachmentsData(params)
            this.list_attachments = response
        },
        //API call to get deal action log data
        async loadActionLog(id) {
            this.loadActionLogSection = true;
                try {
                    let params = {
                        id: id,
                        skip: 0,
                        limit: 50,
                    }
                    let response = await this.getDealsActionLog(params);
                    this.action_logs = response.response
                    this.loadActionLogSection = false;
                } catch (error) {
                    this.loadActionLogSection = false;
                }
            },
            //API call to get amount associated with caontact data
        async loadAmountContactsAPI(){
            this.loadContactsSmountSection = true;
            try {
                let params ={
                    skip: 0,
                    limit: 10
                }
                let response = await this.getAmountAssociatedData(params)
                this.contacts_data = response.response.contact_amount
                this.scale_data = response.response.graph_scale
                const result = []
                const map = new Map();
                for (const item of this.contacts_data) {
                    if(!map.has(item.sum)){
                        map.set(item.sum, true);
                        result.push({
                            country: item.contact_name || '',
                            visits:item.sum
                        });
                    }
                }
                this.contacts_data = result
                 for (const scaledata of this.scale_data) {
                    scale.push(scaledata)
                }
                this.scale_data = scale
                this.loadContactsSmountSection = false;
            } catch (reason) {
                this.loadContactsSmountSection = false;
            }
            if(this.contacts_data == ''){
                this.loadContactsSmountSection = true;
                setTimeout(() => {
                    var style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerHTML = '.surveyTypeCss {width: 180px !important;height: 120px;margin: auto !important;margin-top:60px !important;  }';
                    document.getElementsByTagName('head')[0].appendChild(style);
                    document.getElementById('amountContactsDiv').innerHTML = "<div class=text-center><img id= type-img src=/static/images/forecast.png class=mt-3><div class='mt-5 text-muted fw-500'>No amount added by Contacts! </div></div>";
                    document.getElementById('type-img').className = 'surveyTypeCss';
                }, 1500);
            } else {
                this.loadContactsSmountSection = false;
                this.loadAmountContactsData()
            }

        },
        //Amchart code to show amount associated with caontact chart
        async loadAmountContactsData(){
            setTimeout(() => {
                let vueThis = this
                let scale = vueThis.scale_data
                am4core.useTheme(am4themes_animated);
                var chart = am4core.create("amountContactsDiv", am4charts.XYChart);
                chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
                chart.data = vueThis.contacts_data
                var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.dataFields.category = "country";
                categoryAxis.renderer.minGridDistance = 10;
                categoryAxis.title.text = "Contacts";
                categoryAxis.title.fontWeight = 600;
                categoryAxis.renderer.grid.template.disabled = true;
                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.renderer.grid.template.location = 0;
                valueAxis.dataFields.category = "visits";
                valueAxis.renderer.minGridDistance = 30;
                valueAxis.title.text = "Amount in 1000(" + vueThis.currency + ")";
                valueAxis.title.fontWeight = 600;
                valueAxis.numberFormatter.numberFormat = "#a";
                //create label
                var label = categoryAxis.renderer.labels.template;
                label.truncate = true;
                label.maxWidth = 70;
                label.tooltipText = "{country}";
                var ylabel = valueAxis.renderer.labels.template;
                ylabel.truncate = true;
                ylabel.maxWidth = 50;
                ylabel.tooltipText = "{value}";

                categoryAxis.events.on("sizechanged", function(ev) {
                var axis = ev.target;
                var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
                if (cellWidth < axis.renderer.labels.template.maxWidth) {
                    axis.renderer.labels.template.rotation = -45;
                    axis.renderer.labels.template.horizontalCenter = "right";
                    axis.renderer.labels.template.verticalCenter = "middle";
                }
                else {
                    axis.renderer.labels.template.rotation = 0;
                    axis.renderer.labels.template.horizontalCenter = "middle";
                    axis.renderer.labels.template.verticalCenter = "top";
                }
                });
                var series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.categoryX = "country";
                series.dataFields.valueY = "visits";
                series.columns.template.tooltipText = "{valueY.value}";
                series.columns.template.tooltipY = 0;
                series.columns.template.strokeOpacity = 0;

                var valueLabel = series.bullets.push(new am4charts.LabelBullet());
                valueLabel.label.text = "{visits}";
                valueLabel.label.fontSize = 8;
                valueLabel.label.fontWeight = 600;
                valueLabel.label.horizontalCenter = "top";
                valueLabel.label.verticalCenter = "top";
                valueLabel.label.fill = am4core.color("#ffffff");
                valueLabel.label.dx = -11;
                valueLabel.label.dy = 10;
                // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
                series.columns.template.adapter.add("fill", (fill, target) => {
                return chart.colors.getIndex(target.dataItem.index);
                });
            // scaleData();
                function scaleData(){
                    for(let j=0;j<scale.length;j++){
                        createGrid(scale);
                    }
                }
                function createGrid(value) {
                    var range = valueAxis.axisRanges.create();
                    range.value = value;
                    range.label.text = value;
                }
            }, 1000);
        },
        //API call to get revenue generated data
        async loadRevenueGeneratedAPI(){
            this.loadRevenueGeneratedSection = true;
            try {
                let params ={
                    range: this.created_report_date
                }
                let response = await this.getRevenueGeneratedData(params)
                this.revenue_data = response.response.timing
                const result = []
                const map = new Map();
                for (const item of this.revenue_data) {
                        map.set(item.total, true);
                        result.push({
                            date: item.concat_time || '',
                            value:item.total
                        });
                }
                this.revenue_data = result
                this.graph_scale = response.response.graph_scale
                for (const scaledata of this.graph_scale) {
                    scale.push(scaledata)
                }
                this.graph_scale = scale
                this.loadRevenueGeneratedSection = false;

            } catch (reason) {
                this.loadRevenueGeneratedSection = false;
            }
            if(this.graph_scale.length == 0){
                this.loadRevenueGeneratedSection = false;
                setTimeout(() => {
                    var style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerHTML = '.revenueCss {width: 180px !important;height: 120px!important;margin: auto !important;margin-top:60px !important;  }';
                    document.getElementsByTagName('head')[0].appendChild(style);
                    document.getElementById('revenueGeneratedDiv').innerHTML = "<div class=text-center><img id= revenue-img src=/static/images/forecast.png class=mt-3><div class='mt-5 text-muted fw-500'>No revenue added!</div></div>";
                    document.getElementById('revenue-img').className = 'revenueCss';
                }, 1000);
            } else {
                this.loadRevenueGeneratedSection = false;
                this.loadRevenueGeneratedData()
            }
            this.loadRevenueGeneratedSection = false;
        },
        //Amchart code to show revenue generated graph
        async loadRevenueGeneratedData(){
            setTimeout(() => {
                let vueThis = this;
                am4core.useTheme(am4themes_animated);
                var chart = am4core.create("revenueGeneratedDiv", am4charts.XYChart);
                chart.paddingRight = 20;
                var data = [];
                var visits = 10;
                for (var i = 1; i < 50000; i++) {
                    visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
                    data.push({ date: new Date(2018, 0, i), value: visits });
                }
                chart.data = this.revenue_data;
                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.grid.template.location = 0;
                dateAxis.minZoomCount = 1;
                dateAxis.title.text = "Time period (T)"
                dateAxis.title.fontWeight = 600;
                // this makes the data to be grouped
                dateAxis.groupData = true;
                dateAxis.groupCount = 500;
                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.title.text = "Amount in 1000(" + vueThis.currency + ") "
                valueAxis.title.fontWeight = 600;
                valueAxis.numberFormatter.numberFormat = "#a";
                //create label
                var ylabel = valueAxis.renderer.labels.template;
                ylabel.truncate = true;
                ylabel.maxWidth = 80;
                ylabel.tooltipText = "{value}";
                var series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.dateX = "date";
                series.dataFields.valueY = "value";
                series.tooltipText = "{valueY}";
                series.tooltip.pointerOrientation = "vertical";
                series.tooltip.background.fillOpacity = 0.5;
                chart.cursor = new am4charts.XYCursor();
                chart.cursor.xAxis = dateAxis;
                var scrollbarX = new am4core.Scrollbar();
                scrollbarX.marginBottom = 20;
                chart.scrollbarX = scrollbarX;
            }, 1000);
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
        callReportCategory() {
            return this.$store.getters.callReportCategory;
        },
    },
    mounted(){
        this.currency = this.loggedInUser.currency.symbol;
        this.dateSettings(),
        this.loadAmountContactsAPI(),
        this.loadContactListData(),
        this.loadRevenueGeneratedAPI()
        // this.loadActionLog()
        //this.getCallReportType()
    },
    created() {
    },
}
</script>
<style scoped>
.column-heading{
    font-size: 14px;
}
.contact-list{
    border-radius: 6px 6px 0 6px;
}
.contact-list-table{
    border: 1px solid #00448b;
    border-radius: 6px;
    width: 100%;
    height: 364px;
    max-height: 100%;
}
.contact-list-table-expand{
    height: 100%;
}
.text-color{
    color: #338DF1;
}
.action-log-table{
    overflow: auto;
    max-height: 356px;
    min-height: 356px;
}
.action-log-table-expand{
    overflow: auto;
    max-height: 830px;
    min-height: 100%;
}
thead{
    position: sticky;
    top: 0;
    background-color: #00448b;
    color: white;
}
.tabBtn{
    display: block;
    width: 33.33%;
    border: 1px solid #00448b;
}
.active-tab{
    background-color: #00448b !important;
    color: #fff !important;
}
.a.nav-link-cd:hover{
    color: #fff !important;
}
.deals-details{
    border: 1px solid #00448b;
    border-radius: 6px;
    width: 100%;
    height: 364px;
    max-height: 100%;
}
.deal-details-expand{
    height: 100%;
    overflow: auto;
}

.clickImg {
    cursor: pointer;
}
.deal-details-expand .clickImg {
    cursor: not-allowed !important;
}
.empty-deal-details{
    width: 250px;
}
.amountContactsDiv{
    width: 100%;
    height: 358px;
    max-height: 100%;
}
.amountContactsDiv-expand{
    width: 100%;
    height: 750px;
    max-height: 100%;
    padding: 90px;
}
.revenueGeneratedDiv{
    width: 100%;
    height: 300px;
    max-height: 100%;
}
.revenueGeneratedDiv-expand{
    width: 100%;
    height: 750px;
    max-height: 100%;
    padding: 90px;
}
.menu{
    display: flex;
    justify-content: space-between;
}
.menu li a{
    font-size: 12px;
    height: 30px;
    display: flex;
    align-items: center !important;
    justify-content: center !important;
}
.deal-action{
    width: 100%;
    height: 410px;
    max-height: 100%;
}
.deal-action-expand{
    width: 100%;
    height: 886px;
    max-height: 100%;
}
.action-div{
    border: 1px solid #00448b;
    border-radius: 6px;
}
.action-log{
    border-radius: 0 0 6px 6px;
}
.expand-img{
    width: 24px;
    margin-bottom: 3px;
}
.schedule-meeting-btn{
    background-color: #00448b;
    border-radius: 6px !important;
}
.call-report-btn{
    background-color: #008A63;
    border-radius: 6px !important;
}
.deal-details-btn{
    background-color: #008A63;
    border-radius: 2px !important;
    cursor: pointer;
    height:25px;
    width: 25px;
}
.notes-parent{
    box-shadow: rgb(147, 147, 147) 0px 0px 6px 0px;
    word-break: break-all;
    margin-top: 12px !important;
    border-radius: 6px;
}
.vertical-scroll{
    overflow: auto;
    max-height: 264px;
    min-height: 264px;
}
.vertical-scroll-expand{
    max-height: 100%;
    min-height: 100%;
}
#selectordiv{
    display: none;
}
.icondefault {
    background: #ddd !important;
    border-color: #ddd !important;
    height: 2.2em !important;
    border-radius: 20px 0px 0px 20px;
    padding: 4px 16px;
}
.team-list-table tbody tr td span img {
    width: 30px !important;
    height: 30px !important;
    margin-left: -10px;
}
.no_data{
    margin: 0 auto;
    display: block;
    text-align: center;
    position: absolute;
    width: 100%;
}
.icon-default-board {
    border-radius: 20px 0px 0px 20px;
    color: #00448b;
    width: 30px;
    font-size: 14px;
    padding: 2px;
    background: #ddd !important;
    border-color: #ddd !important;
    height: 30px!important;
    padding: 4px 16px;
}
.searchText {
    border-radius: 0px 20px 20px 0px !important;
    padding-left: 10px;
    background-color: #ddd;
    width: 100% !important;
}
.search-height {
    height:25px !important
}
.box-radius{
    border-radius: 7px !important;
}

.flex-column {
    flex-direction: column !important;
}
.mb-9 {
    margin-bottom: 2rem !important;
}
.me-5 {
    margin-right: 1.25rem !important;
}
.attachemntimg {
    display: inline-block;
    flex-shrink: 0;
    position: relative;
    border-radius: 0.475rem;
    width: 80px;
    text-align: center;
}

.attachemntimg > img {
    width: 100%;
    flex-shrink: 0;
    display: inline-block;
    border-radius: 0.475rem;
}
.attachemntimg.attachemntimg-80px > img {
    width: 80px;
}
.fw-semibold {
    font-weight: 500 !important;
}

.text-hover-primary {
    transition: color 0.2s ease;
    text-decoration: none;
}

.text-hover-primary:hover {
    transition: color 0.2s ease;
    color: #338df1 !important;
}
.fw-bold {
    font-weight: 600 !important;
}
.fs-6 {
    font-size: 13px !important;
}
.text-gray-400 {
    color: #5E6278;
}
.btn-wide-smm {
    height: 32px !important;
    border-radius: 6px !important;
    font-size: 14px !important;
    line-height: 32px !important;
    text-transform: none !important;
    font-weight: 600 !important;
}
.call-report-dropdown.contact-dash{
    left: 666px !important;
}
.cont-table-row:hover{
    box-shadow: 0px 0px 6px darkgray;
    cursor: pointer;
}
.active{
    box-shadow: 0px 0px 6px darkgray;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ContactsDashboard.vue